// extracted by mini-css-extract-plugin
export default {"custom_modal_contianer":"index_custom_modal_contianer__BbGCS","custom_footer":"index_custom_footer__T0rPZ","custom_modal_contianer1":"index_custom_modal_contianer1__qAcCI"};